<template>
  <div class="read-comment-content" tabindex="-1" ref="content">
    <span
      class="single-obituary-comment__date"
      v-if="comment.date"
      v-text="timeSinceDate(comment.date)"
    />
    <p class="single-obituary-comment__text" v-html="comment.comment" />
  </div>
</template>

<script>
  import { useDateFormatter } from "Composables/useDateFormatter";

  export default {
    name: "ReadCommentContent",

    props: {
      comment: {
        required: true,
        type: Object,
      },
      modalOpen: {
        default: false,
        type: Boolean,
      },
    },

    setup() {
      const { timeSinceDate } = useDateFormatter();

      return { timeSinceDate };
    },

    watch: {
      // Move focus into the modal so keyboard and screen reader users land on
      // the greeting they asked to read.
      modalOpen: {
        handler(isOpen) {
          if (isOpen) {
            this.$nextTick(() => this.$refs.content?.focus());
          }
        },
        immediate: true,
      },
    },
  };
</script>
